// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Zo6nU","productName":"Table_productName__2phVn"};